import { render, staticRenderFns } from "./HotelList.vue?vue&type=template&id=57f05540&"
import script from "./HotelList.vue?vue&type=script&lang=js&"
export * from "./HotelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports